import http from "../httpService.js";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/production/production-report/";

export function getProductionDashboard(fiscalYearID = 0, fiscalPeriodID = 0) {
  return http.get(
    apiEndpoint + "production-dashboard/" + fiscalYearID + "/" + fiscalPeriodID
  );
}
